import { DotLegalDialog, DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../../localization/useTranslation";
import useStartPageSelectorDialog from "./StartPageSelectorDialog.hooks";

export interface IStartPageSelectorDialogProps {
    onDialogClose: () => void;
}

function StartPageSelectorDialog(props: IStartPageSelectorDialogProps) {
    const { translateString } = useTranslation();
    const { userStartPageOptions, isLoading, userStartPage, setUserStartPage, updateStartPage, isSaving } = useStartPageSelectorDialog(props);

    return (
        <DotLegalDialog
            header={translateString("setStartPage")}
            buttonOkText={translateString("save")}
            size="sm"
            open
            onDialogClose={props.onDialogClose}
            onOkClick={() => updateStartPage()}
            inProgress={isSaving}
        >
            <DotLegalSelect
                isLoading={isLoading}
                options={userStartPageOptions}
                onChange={(page) => setUserStartPage(page!)}
                label={translateString("startPage")}
                noOptionsLabel={translateString("noOptions")}
                selectedItem={userStartPage}
                disableClearable
            />
        </DotLegalDialog>
    );
}

export default StartPageSelectorDialog;
